import {createContext, useContext} from 'react';
import {sharedIconAssets} from './sharedIconsAssets';

export enum GenericIconName {
  AboutYouKnob = 'AboutYouKnob',
  AddCircle = 'AddCircle',
  AddCircleFill = 'AddCircleFill',
  AddToBasket = 'AddToBasket',
  AddToBasketFilled = 'AddToBasketFilled',
  AddToBasketWithCheckMark = 'AddToBasketWithCheckMark',
  AlertError = 'AlertError',
  AlertSuccess = 'AlertSuccess',
  CheckmarkBorder = 'CheckmarkBorder',
  CouponCloud = 'CouponCloud',
  CouponNav = 'CouponNav',
  AlertSuccessFill = 'AlertSuccessFill',
  AlertErrorFill = 'AlertErrorFill',
  AlertErrorCircleFill = 'AlertErrorCircleFill',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowLongRight = 'ArrowLongRight',
  ArrowRight = 'ArrowRight',
  ArrowSmallRight = 'ArrowSmallRight',
  ArrowUp = 'ArrowUp',
  Chatbot = 'Chatbot',
  Checkmark = 'Checkmark',
  CheckmarkSmall = 'CheckmarkSmall',
  CheckmarkCircle = 'CheckmarkCircle',
  CheckmarkCircleWhiteCheck = 'CheckmarkCircleWhiteCheck',
  ChevronDown = 'ChevronDown',
  Coins = 'Coins',
  CoinsIconDark = 'CoinsIconDark',
  Clock = 'Clock',
  Close = 'Close',
  CloseSmall = 'CloseSmall',
  Coupons = 'Coupons',
  CreditCard = 'CreditCard',
  Discount = 'Discount',
  DoubleArrow = 'DoubleArrow',
  Download = 'Download',
  Dropdown = 'Dropdown',
  EmptySearch = 'EmptySearch',
  Error = 'Error',
  ExternalLink = 'ExternalLink',
  ExternalLinkBordered = 'ExternalLinkBordered',
  Filter = 'Filter',
  FitAdvisor = 'FitAdvisor',
  FlagReport = 'FlagReport',
  Grabber = 'Grabber',
  Globe = 'Globe',
  GridMultiCol = 'GridMultiCol',
  GridSingleCol = 'GridSingleCol',
  Hashtag = 'Hashtag',
  Heart = 'Heart',
  HeartAdd = 'HeartAdd',
  HeartFilled = 'HeartFilled',
  Help = 'Help',
  Info = 'Info',
  InfoFill = 'InfoFill',
  InfoFilled = 'InfoFilled',
  InfoFilledGray = 'InfoFilledGray',
  InfoSquaredGray = 'InfoSquaredGray',
  InfoSponsored = 'InfoSponsored',
  List = 'List',
  Lock = 'Lock',
  Locked = 'Locked',
  Mail = 'Mail',
  MailBlack = 'MailBlack',
  More = 'More',
  NavBasket = 'NavBasket',
  NavHeaderBasket = 'NavHeaderBasket',
  NavHeaderWishlist = 'NavHeaderWishlist',
  NavHeaderSearch = 'NavHeaderSearch',
  NavUser = 'NavUser',
  ParcelBox = 'ParcelBox',
  Phone = 'Phone',
  Reset = 'Reset',
  Ruler = 'Ruler',
  Search = 'Search',
  SecondHandService = 'SecondHandService',
  Settings = 'Settings',
  Share = 'Share',
  ShareAndroid = 'ShareAndroid',
  SmileyHappy = 'SmileyHappy',
  SmileySad = 'SmileySad',
  SocialWhatsapp = 'SocialWhatsapp',
  Trash = 'Trash',
  Unlocked = 'Unlocked',
  UnlockedFilled = 'UnlockedFilled',
  USPReturn = 'USPReturn',
  User = 'User',
  UspProofOfQuality = 'UspProofOfQuality',
  UspFreeShipping = 'UspFreeShipping',
  Vip = 'Vip',
  Warning = 'Warning',
  WarningFill = 'WarningFill',
  QuestionMark = 'QuestionMark',
  Sale = 'Sale',
  SaleBG = 'SaleBG',
  SalePercent = 'SalePercent',
  Percent = 'Percent',
  FullscreenOpener = 'FullscreenOpener',
  Pause = 'Pause',
  PauseRound = 'PauseRound',
  Play = 'Play',
  Mute = 'Mute',
  Unmute = 'Unmute',
  YourFiltersHint = 'YourFiltersHint',
  StarFilled = 'StarFilled',
  StarOutline = 'StarOutline',
  SearchHistory = 'SearchHistory',
  SaleCloud = 'SaleCloud',
  SaleCloudPercent = 'SaleCloudPercent',
  InfoWithoutFill = 'InfoWithoutFill',
  Bell = 'Bell',
  BellFilled = 'BellFilled',
  DropdownUpRight = 'DropdownUpRight',
  Coupon = 'Coupon',
  NotificationCenterEmptyState = 'NotificationCenterEmptyState',
  BestPriceGuaranteeWallet = 'BestPriceGuaranteeWallet',
  Loudspeaker = 'Loudspeaker',
  Merchant = 'Merchant',
  SustainabilityLeaf = 'SustainabilityLeaf',
  InfoOutline = 'InfoOutline',
  Size = 'Size',
  SaleEvent = 'SaleEvent',
  SmallSaleEvent = 'SmallSaleEvent',
  AppOnlyCoupon = 'AppOnlyCoupon',
  AppOnlyIcon = 'AppOnlyIcon',
  ArrowUpSharpCorners = 'ArrowUpSharpCorners',
  CouponExpired = 'CouponExpired',
  ErrorTriangle = 'ErrorTriangle',
  ErrorTriangleColor = 'ErrorTriangleColor',
  RightArrowSharpEdges = 'RightArrowSharpEdges',
  couponHintCloud = 'couponHintCloud',
  copy = 'copy',
  CoinsStriped = 'CoinsStriped',
  CoinsFilled = 'CoinsFilled',
  CoinsDoubleColor = 'CoinsDoubleColor',
  CoinsDoubleColorSuccess = 'CoinsDoubleColorSuccess',
  BasketLock = 'BasketLock',
  LongArrow = 'LongArrow',
  CrossFill = 'CrossFill',
  PlayOutline = 'PlayOutline',
  DropsSneaker = 'DropsSneaker',
  PriceInfo = 'PriceInfo',
  Confetti = 'Confetti',
  OpenedBox = 'OpenedBox',
  Shirts = 'Shirts',
  Spinner = 'Spinner',
  Wallet = 'Wallet',
}

export type IconName = keyof typeof sharedIconAssets;

export const iconNamesContext = createContext<
  {[key in IconName]: string} | null
>(null);

export function useSharedIconUrl(iconName: IconName): string {
  const assets = useContext(iconNamesContext);

  if (!assets) {
    throw new Error(
      `Cannot find icon \`${iconName}\`. This is most probably caused because the \`IconsProvider\` is not rendered as a parent of this component.`,
    );
  }

  return assets[iconName];
}
